module.exports = __webpack_public_path__ + "img/police.b311b5ff.png";